import { Suspense, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Outlet, useSearchParams } from 'react-router'
import { useAppSelector } from 'universal-scripts'
import ErrorBoundary from '@components/ErrorBoundary/ErrorBoundary'
import ErrorMessage from '@components/ErrorBoundary/ErrorMessage'
import ProfileAnalyticsDialog from '@components/dialog/ProfileAnalyticsDialog/ProfileAnalyticsDialog'
import { useProfileExtras } from '@hooks/useProfileExtras'

import './ProfileData.css'

interface ProfileAnalyticsProps {
  setIsDialogOpen: (isOpen: boolean) => void
  setIsBlocking: (isBlocking: boolean) => void
  isOnboard: boolean
}
const EMPTY_ARRAY: string[] = []

const ProfileAnalytics = ({ setIsDialogOpen }: ProfileAnalyticsProps) => {
  const { analytics } = useProfileExtras()
  const propertyIds = analytics?.propertyIds || EMPTY_ARRAY

  const isEmpty = propertyIds.length === 0

  if (isEmpty) return null

  return (
    <li id="profile-analytics">
      <h3>
        <FormattedMessage id="profile.analytics" />
      </h3>
      <ul>
        {propertyIds.map((p) => {
          return (
            <li key={'key-' + p}>
              <span>{p}</span>
              <span className="icon icon-verify" />
            </li>
          )
        })}
      </ul>
      <button onClick={() => setIsDialogOpen(true)}>
        <span className="plus">+</span>
        <span>
          <FormattedMessage id="profile.analytics-button" />
        </span>
      </button>
    </li>
  )
}

export default function ProfileData() {
  const { company_name, company_nif, email, name } = useAppSelector(
    (state) => state.user
  )
  const [searchParams] = useSearchParams()
  const isOnboard = searchParams.get('onboard') === '1'
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [isBlocking, setIsBlocking] = useState(false)

  const profileFields = [
    { id: 'profile.name', value: name },
    { id: 'profile.email', value: email },
    { id: 'profile.companyName', value: company_name },
    { id: 'profile.companyNif', value: company_nif }
  ]

  return (
    <section id="profile-data">
      <ul>
        {profileFields.map(({ id, value }) => (
          <li key={id}>
            <h3>
              <FormattedMessage id={id} />:
            </h3>
            <span> {value}</span>
          </li>
        ))}
        <ErrorBoundary errorComponent={ErrorMessage}>
          <Suspense fallback="">
            <ProfileAnalytics
              setIsDialogOpen={setIsDialogOpen}
              setIsBlocking={setIsBlocking}
              isOnboard={isOnboard}
            />
          </Suspense>
        </ErrorBoundary>
      </ul>
      <ProfileAnalyticsDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        isBlocking={isBlocking}
      />
      <Outlet />
    </section>
  )
}
